const columns = [
  {
    id: "nav",
    title: "快捷导航",
    links: [
      { id: "n1", label: "投稿入口", href: "#submit" },
      { id: "n2", label: "曝光台", href: "#board" },
      { id: "n3", label: "线索热度榜", href: "#ranking" },
      { id: "n4", label: "审核机制", href: "#flow" },
    ],
  },
  {
    id: "way",
    title: "投稿方式",
    links: [
      { id: "w1", label: "私信投稿", href: "#submit" },
      { id: "w2", label: "曝光台线索提交", href: "#submit" },
      { id: "w3", label: "热门话题标签", href: "#board" },
      { id: "w4", label: "常见问题", href: "#faq" },
    ],
  },
  {
    id: "rule",
    title: "社区说明",
    links: [
      { id: "c1", label: "隐私与安全承诺", href: "#privacy" },
      { id: "c2", label: "线索合规标准", href: "#flow" },
      { id: "c3", label: "内容脱敏说明", href: "#privacy" },
      { id: "c4", label: "补充材料指引", href: "#board" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 px-4 md:px-8 pt-14 pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-alarm-warning-line text-xl text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料社区</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-sm">
              黑料社区提供匿名投稿通道，支持私信投稿或直接提交线索到曝光台。无需暴露身份即可发布爆料内容，
              投稿后由社区审核展示。
            </p>
            <div className="mt-6 flex items-center gap-2">
              <span className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-primary-900/60 text-background-200 text-xs whitespace-nowrap">
                <i className="ri-lock-2-line text-sm"></i>
                匿名优先
              </span>
              <span className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-primary-900/60 text-background-200 text-xs whitespace-nowrap">
                <i className="ri-shield-check-line text-sm"></i>
                审核后展示
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.id} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-background-100">
                <a href="#top" className="hover:text-accent-300 transition-colors cursor-pointer">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-bold text-background-100">
              <a href="#submit" className="hover:text-accent-300 transition-colors cursor-pointer">
                联系
              </a>
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="#submit"
                  className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  投稿邮箱
                </a>
              </li>
              <li>
                <a
                  href="#submit"
                  className="text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  值班编辑
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            © 2026 黑料社区 · 匿名投稿与曝光线索平台
          </p>
          <p className="text-xs text-background-400 text-center sm:text-right">
            平台仅提供线索收集与审核展示，内容以社区审核结果为准
          </p>
        </div>
      </div>
    </footer>
  );
}